import { Promise } from 'es6-promise';

import { MAV } from '../../constants';
import inventoryFactory from './requestFactory';
import FSA from '../FSA';

import IReportSettings from '../../interfaces/IReportSettings';
import ISettings from '../../components/widget/inventory/listInventory/ISettings';

interface ISystemEventsMap {
    nodeId?: ISystemEvents[]
}

interface ISystemEvents {
    nodeId?: string
}

interface IParams {
    customerId: string,
    settings: ISettings,
    reportSettings: IReportSettings,
}

export function fetchContainer(requesterId: string, customerId: string): any {
    return inventoryFactory.get(`3/customer/${customerId}/containers`, {});
}

function getInventoryCategories(settings: ISettings): string[] {
    const categories = ["BIOS", "DISK", "MEMORY", "CPU", "OS", "STORAGE", "WIN_11_STATUS"]; // Default fields;

    if (settings.displayCategorySYSTEM) {
        categories.push("SYSTEM");
    }
    if (settings.displayCategoryMEMORYDEVICE) {
        categories.push("MEMORYDEVICE");
    }
    if (settings.displayCategoryDISPLAY) {
        categories.push("DISPLAY");
    }
    if (settings.displayCategoryOS_HOTFIX) {
        categories.push("OS_HOTFIX");
    }
    if (settings.displayCategoryLOCALINFO) {
        categories.push("LOCALINFO");
    }
    if (settings.displayCategoryPROGRAMS) {
        categories.push("PROGRAMS");
    }
    if (settings.displayCategoryNEVI) {
        categories.push("NEVI");
    }

    return categories;
}

export function fetchInventoryByContainer(requesterId: string, containerId: string, settings: ISettings): any {
    const fieldList = getInventoryCategories(settings);

    return inventoryFactory.get(`3/container/${containerId}/inventory`, {
        $fields: fieldList,
    });
}
export function fetchInventoryByCustomer(requesterId: string, customerId: string, settings: ISettings): any {
    const fieldList = getInventoryCategories(settings);

    return inventoryFactory.get(`3/customer/${customerId}/inventory`, {
        $fields: fieldList
    });
}

function listInventory(requesterId: string, params: IParams): Function {
    return dispatch => {
        dispatch(new FSA(MAV.FETCH_INVENTORY_REQUEST).addMeta({ requesterId }).data);

        const { customerId, settings } = params;
        const { includeTags, excludeTags } = settings;

        return fetchContainer(requesterId, customerId).then(containers => {
            // CHECK: Only CAC container can have inventories? Other filters necessary?
            let cacContainer = containers.filter(container => container.type === "CAC");

            if (includeTags && includeTags.length) {
                cacContainer = cacContainer.filter(container => {
                    const containerTags = container.tags.map(tag => tag.tagId);
                    return containerTags.some(r => includeTags.indexOf(r) >= 0);
                });
            }

            if (excludeTags && excludeTags.length) {
                cacContainer = cacContainer.filter(container => {
                    const containerTags = container.tags.map(tag => tag.tagId);
                    return !containerTags.some(r => excludeTags.indexOf(r) >= 0);
                });
            }

            fetchInventoryByCustomer(requesterId, customerId, settings).then(inventories => {
                // Merge container data with inventory
                const resultData = cacContainer.map((container, index) => {
                    const containerInventory = inventories[cacContainer[index].containerId];

                    if (containerInventory) {
                        return {
                            ...container,
                            inventory: containerInventory
                        };
                    }
                    return {
                        ...container,
                        inventory: {}
                    };
                });

                dispatch(new FSA(MAV.FETCH_INVENTORY_SUCCESS).addPayload(resultData).addMeta({ requesterId }).data);
            }).catch(err => {
                console.warn("::: fetchInventoryByCustomer result with errors", err);
                dispatch(new FSA(MAV.FETCH_INVENTORY_FAILURE).addError(err).addMeta({ requesterId }).data);
                throw err;
            });
        });
    }
}

export {
    ISystemEvents,
    ISystemEventsMap,
    listInventory,
};


// WEBPACK FOOTER //
// ./src/actions/inventory/Inventory.ts